import { metrics } from '@seek/metrics-js';
import { Text, Button, Inline, Stack } from 'braid-design-system';
import { useEffect, useRef } from 'react';

import type { ProfileScoreTipAction } from 'src/types/graphql';

import { TipLink } from './TipLink/TipLink';

import * as styles from './Tip.css';

interface TipProps {
  description: string;
  label: string;
  action: ProfileScoreTipAction;
  active: boolean;
  id: string;
  hidden: boolean;
  index: number;
}

export const Tip = ({
  description,
  label,
  action,
  active,
  id,
  hidden,
  index,
}: TipProps) => {
  const previousIdRef = useRef(id);

  useEffect(() => {
    if (active && previousIdRef.current !== id) {
      metrics.count('nudge_shown', [`id:${id}`]);
    }

    previousIdRef.current = id;
  }, [active, id]);

  return hidden ? null : (
    <Stack space="large">
      <div className={styles.tipText}>
        <Text data={{ automation: `tip-text-${id}-${index}` }}>
          {description}
        </Text>
      </div>

      <Inline space="none" data={{ automation: `tip-link-${id}-${index}` }}>
        <TipLink
          nudgeText={label}
          action={action}
          component={Button}
          variant="ghost"
          tone="neutral"
        />
      </Inline>
    </Stack>
  );
};
